import styled, { createGlobalStyle, css } from 'styled-components'
const types = {
  warning: {
    icon: {
      backgroundColor: '#FAECCA'
    }
  },
  default: {
    icon: {
      backgroundColor: '#FFF2EE'
    }
  }
}

export const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  visibility:  ${props => (props.isVisible ? 'visible' : 'hidden')};
  opacity:  ${props => (props.isVisible ? '1' : '0')};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  transition: .3s;
  ${({ mobile }) => mobile && css`
    width: 100vw;
    height: 100vh;
    padding: 16px;
    .ModalContent {
      width: 328px;
      margin: 0 auto;
    }
  `}
`
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-radius: 16px;
  width: 560px;
  padding: 16px;
`
export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`
export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 64px;
  overflow: hidden;
  width: 64px;
  height: 64px;
  margin-top: 0;
  margin-bottom: 24px;
  svg {
    width: 44px;
    height: 44px;
  }
  ${({ type = 'default' }) => {
    return {
      ...types[type].icon
    }
    }}
`
export const Title = styled.h3`
  padding: 0;
  color: #222;
  font-family: 'Open Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 16px;
  ${({ variation }) => css`${variation}`}
`
export const SubTitle = styled.p`
  color: #555;
  text-align: center;
  font-family: 'Open Sans';
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 24px;
`
export const PreventScroll = createGlobalStyle`
  html {
    overflow: hidden;
  }
`
